import React from 'react'

const IconCursorTool = ({ style }) => {
   return (
      <svg viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' style={style}>
         <path d='M5 3l5 16 2.5-6.5L19 10 5 3Z' />
      </svg>
   )
}
export default IconCursorTool
